import React from "react";
import {connect} from "react-redux";
import {compose} from "recompose";
import {reduxForm} from "redux-form";
import {validate} from "../data";
import InputField from "../components/input-field";
import ProgressBar from "../components/progress-bar";
import DidYouKnow from "../components/did-you-know";
import {AdvanceButton, RevertButton} from "../components/buttons";


const enhance = compose(
  reduxForm({form: 'wizard', destroyOnUnmount: false, forceUnregisterOnUnmount: true, validate}),
  connect(
    (state) => ({ formWizard: state.form.wizard }),
    (dispatch) => ({})
  )
);

export default enhance(({header, didYouKnow, input, progress, formWizard: { syncErrors = {}}, addon, addonType, ...rest}) => {
  const hasErrors = input.name in syncErrors;
  return (
    <div className="progress-page animated fadeInDown">
      <div className="columns is-centered">
        <div className="column is-half is-narrow">
          <div className="progress-page box" id={`step-${progress.progress}`}>
            <div className="">
              <div className="columns">
                <div className="column is-6 is-offset-3">
                  <ProgressBar {...progress} />
                </div>
              </div>
              <div className="columns is-centered">
                <div className="column is-12">
                  <div className="header">
                    <h1>{header}</h1>
                  </div>
                </div>
              </div>
              <div className="body">
                <div className="columns is-centered">
                  <div className="column is-10 is-12-mobile">
                    <InputField {...input} onKeyPress={e => {
                      if (e.key === 'Enter' && !hasErrors) { rest.advance(); rest.next(); }
                    }} addon={addon} addonType={addonType} />
                  </div>
                </div>
                <div className="columns">
                  <div className="column is-10 is-offset-1">
                    <DidYouKnow tidbit={didYouKnow} />
                  </div>
                </div>
                <div className="columns is-centered v-centered">
                  <div className="buttons has-text-centered">
                    <RevertButton text="Back" {...rest}/>
                    <AdvanceButton disabled={hasErrors} text="Next" {...rest}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
});



// WEBPACK FOOTER //
// ./src/pages/progress-page.js